<template>
  <div class="xcard">
    <v-btn small class="ma-0" @click="$router.back()" color="info" tile outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras
    </v-btn>
    <h3 class="text-center my-0">Proyeccion por Unidades de negocio</h3>
    <hr />

    <v-row no-gutters>
      <v-col class="pr-1" cols="12" sm="2">
        <v-text-field v-model="input.fecha_inicio" type="date" label="Fecha inicio:" outlined dense hide-details />
      </v-col>

      <v-col class="pr-1" cols="12" sm="2">
        <v-text-field v-model="input.fecha_fin" type="date" label="Fecha fin:" outlined dense hide-details />
      </v-col>

      <v-col class="pr-1" cols="12" sm="3">
        <v-select
          v-model="input.universidad_id"
          :items="convenios"
          :loading="optionsloading"
          label="Universidad:"
          item-value="id"
          dense
          hide-details
          outlined></v-select>
      </v-col>
      <v-col class="pr-1" cols="12" sm="3">
        <v-select
          v-model="input.unidad_id"
          :items="unidades"
          :loading="optionsloading"
          label="Unidad:"
          item-value="id"
          dense
          hide-details
          outlined></v-select>
      </v-col>

      <v-col class="pl-0" cols="12" sm="2">
        <v-btn dense tile class="green darken-3" dark @click="precarga()"> Buscar </v-btn>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col class="pl-4" cols="12" sm="6">
        <v-switch v-model="view_categorias" label="Por categorias" dense hide-details />
      </v-col>
    </v-row>

    <v-progress-linear indeterminate color="purple" class="mb-2" v-if="loading" />
    <p class="my-0 text-center red--text">{{ msg }}</p>

    <div v-if="!view_categorias">
      <div v-if="datos.length > 0" class="text-right">
        <v-btn dense tile color="purple" outlined dark class="mb-1" small @click="tableToExcel('table1')">
          <v-icon left>mdi-download</v-icon> Descargar excel
        </v-btn>
      </div>
      <div class="table-responsive">
        <table class="xtable table-hover" ref="table1">
          <thead class="text-center green darken-4 white--text">
            <tr class="white--text">
              <th class="text-center fixedheader" rowspan="2">Sede</th>
              <th :colspan="meses_header.length">Meses</th>
            </tr>
            <tr class="white--text">
              <th v-for="m in meses_header" :key="m.nombre">{{ m.nombre }}</th>
            </tr>
          </thead>

          <tbody class="text-right">
            <template v-for="(d,indice) in datos">
              <tr class="cuerpo" :key="d">
                <td rowspan="1" class="text-left"> <b>{{indice+1}}.-</b> {{ d.sede.nombre }}</td>
                <template v-for="m in d.meses">
                  <td class="text-right" :key="m.xindex">{{ parsecomas(m.total) }}</td>
                </template>
              </tr>
            </template>
            <tr>
              <td rowspan="2" class="xrowtotal">TOTAL</td>
            </tr>
            <tr>
              <td v-for="m in meses_header" :key="m.nombre" class="xrowtotal">{{ parsecomas(m.xtotal_mes) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div v-else>
      <div v-if="datos.length > 0" class="text-right">
        <v-btn dense tile color="purple" outlined dark class="mb-1" small @click="tableToExcel('table2')">
          <v-icon left>mdi-download</v-icon> Descargar excel
        </v-btn>
      </div>
      <div class="table-responsive">
        <table class="xtable table-hover" ref="table2">
          <thead class="text-center green darken-4 white--text">
            <tr class="white--text">
              <th class="text-center fixedheader" rowspan="2" colspan="2">Sede</th>
              <th :colspan="meses_header.length">Meses</th>
            </tr>
            <tr class="white--text">
              <th v-for="m in meses_header" :key="m">{{ m.nombre }}</th>
            </tr>
          </thead>

          <tbody class="text-right">
            <template v-for="(d,indice) in datos">
              <tr class="cuerpo" :key="d">
                <td :rowspan="d.xrowspan2" class="text-left"><b>{{indice+1}}.-</b> {{ d.sede.nombre }}</td>
              </tr>
              <template v-for="(m, j) in d.meses">
                <template v-for="c in m.categorias">
                  <tr v-if="j == 0" class="cuerpo" :key="c">
                    <td style="width: 150px !important">{{ c.nombre }}</td>

                    <template v-for="(mm, l) in d.meses">
                      <!-- <td :key="mm"> {{ m.categorias[l] }} {{ d.meses[l].categorias[k].monto }} {{ k }}</td> -->
                      <td class="text-right" :key="mm">
                        {{
                          d.meses[l].categorias.find((x) => x.nombre == c.nombre)
                            ? parsecomas(d.meses[l].categorias.find((x) => x.nombre == c.nombre).monto)
                            : ''
                        }}
                      </td>
                    </template>
                  </tr>
                </template>
              </template>
            </template>
            <tr>
              <td rowspan="2" class="xrowtotal"></td>
            </tr>
            <tr>
              <td class="xrowtotal">TOTAL</td>
              <td v-for="m in meses_header" :key="m.nombre" class="xrowtotal">{{ parsecomas(m.xtotal_mes) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <toexcel ref="toexcel" />
  </div>
</template>

<style>
  @import url('./stilotablas.css');
</style>

<script>
  import gql from 'graphql-tag';
  import toexcel from './toexcel';
  import xaxios from '@/xaxios';
  export default {
    data() {
      return {
        datos: [],
        optionsloading: false,
        view_categorias: false,
        meses_header: [],
        convenios: [],
        unidades: [],
        msg: '',
        loading: false,
        input: {
          fecha_inicio: null,
          fecha_fin: null,
          universidad_id: null,
          unidad_id: null,
        },
      };
    },
    components: { toexcel },
    watch: {},
    computed: {},
    methods: {
      tableToExcel(table) {
        if (!table.nodeType) table = this.$refs[table];
        this.$refs.toexcel.tableToExcel(table, 'proy-unidades.xls');
      },
      parsecomas(str) {
        if (str == null) return '';
        try {
          if (!str) str = 0;
          let number = window.accounting.formatMoney(str, '', 2, '.', ',');
          return number;
        } catch (e) {
          window.console.error(e);
          return str;
        }
      },
      getrowspan(d) {
        let categorias = 0;
        let max_categorias = 0;
        d.meses.forEach((x) => {
          categorias += x.categorias.length;
          max_categorias = x.categorias.length;
        });
        categorias += d.meses.length;
        d.xrowspan2 = max_categorias + 1;
        d.xrowspan = categorias + 1;
      },
      addCategoriasFaltantes(data, xcates) {
        let vue = this;
        data.meses.forEach((m) => {
          xcates.forEach((xc) => {
            let existe = m.categorias.find((c) => c.nombre == xc.nombre);
            if (!existe) {
              let copia = JSON.parse(JSON.stringify(xc));
              copia.monto = null;
              copia.nombre += '';
              m.categorias.push(copia);
            }
          });
        });
        vue.getrowspan(data);
      },
      async getConveniosUniversidades() {
        this.optionsloading = true;
        let q =
          'query{ getInstituciones(estado:true){id,nombre,tipo,convenio,abreviatura} NegociosAll {   id   nombre } }';
        const sql = gql`
          ${q}
        `;
        this.$apollo.query({ query: sql }).then(({ data }) => {
          let conves = data.getInstituciones;
          let units = data.NegociosAll;
          conves.map((x) => {
            x.text = `[${x.abreviatura}] ${x.nombre}`;
          });
          units.map((x) => {
            x.text = `[${x.id}] ${x.nombre}`;
          });
          conves = conves.filter((x) => {
            return x.convenio;
          });
          conves.unshift({ id: 0, text: '[0] BUSCAR DE TODOS' });
          this.convenios = conves;
          this.unidades = units;
          this.optionsloading = false;
        });
      },
      precarga() {
        this.msg = '';
        if (!this.input.fecha_inicio) this.msg = 'ingrese fecha de inicio';
        if (!this.input.fecha_fin) this.msg = 'ingrese fecha fin';
        if (this.input.universidad_id == null) this.msg = 'ingrese universidad';
        if (!this.input.unidad_id) this.msg = 'ingrese unidad';
        if (this.msg) return;
        this.cargarfromserver();
      },
      cargarfromserver() {
        this.loading = true;
        this.datos = [];
        let vue = this;
        let params = `api/v1/esam/proyeccion/unidades_negocios?unidad_negocio_id=${this.input.unidad_id}&fecha_inicio=${this.input.fecha_inicio}&fecha_fin=${this.input.fecha_fin}&universidad_id=${this.input.universidad_id}`;
        const url = `${process.env.VUE_APP_API_REST}/${params}`;
        xaxios
          .get(url)
          .then(({ data }) => {
            window.console.log(data.data);
            vue.defecto(data.data);
            vue.loading = false;
          })
          .catch((e) => {
            window.console.log(e);
            vue.msg = e;
            vue.loading = false;
          });
      },
      parseJson(data) {
        let existentes = [];
        data.forEach((d) => {
          d.meses.forEach((m) => {
            let ex = existentes.find((xm) => xm.nombre == m.nombre);
            let copia = JSON.parse(JSON.stringify(m));
            copia.xtotal_mes = m.total;
            if (!ex) existentes.push(copia);
            else ex.xtotal_mes += m.total;
          });
        });
        existentes.sort((a, b) => {
          return a.numero - b.numero;
        });
        data.forEach((d) => {
          let xm = [];
          existentes.forEach((m) => {
            let existemes = d.meses.find((xm) => xm.nombre == m.nombre);
            if (!existemes) xm.push({ nombre: m, numero: -1, categorias: [], conceptos: [] });
            else xm.push(JSON.parse(JSON.stringify(existemes)));
          });
          d.meses = xm;
        });
        return existentes;
      },
      defecto(data) {
        let vue = this;
        let xmeses = this.parseJson(data);
        let xindex = 1;

        data.forEach((x) => {
          x.meses.forEach((m) => {
            m.categorias.sort((a, b) => {
              return a.nombre.localeCompare(b.nombre);
            });
          });
        });

        data.forEach((x) => {
          x.xindex = xindex++;
          vue.getrowspan(x);
          let size_categorias_min = 0;
          let size_categorias_max = 0;
          let xcategorias = [];

          x.meses.forEach((m, j) => {
            m.xindex = xindex++;
            if (j == 0) {
              size_categorias_min = m.categorias.length;
              size_categorias_max = m.categorias.length;
              xcategorias = JSON.parse(JSON.stringify(m.categorias));
            } else {
              let sz = m.categorias.length;
              if (sz < size_categorias_min) size_categorias_min = sz;
              if (sz > size_categorias_max) {
                size_categorias_max = sz;
                xcategorias = JSON.parse(JSON.stringify(m.categorias));
              }
            }
            m.categorias.forEach((c) => {
              c.xindex = xindex++;
            });
          });

          if (size_categorias_max - size_categorias_min != 0) {
            this.addCategoriasFaltantes(x, xcategorias);
          }
        });

        this.meses_header = xmeses;
        this.datos = data;
      },
    },
    mounted() {
      this.getConveniosUniversidades();
    },
  };
</script>
